import { ItemAgreementPriceDTO, PriceListItemDTO, PriceType, PriceUnit } from '../dto';

export interface PriceListItemProps {
  mgSupplierItemId: number;
  mgItemNumber: number;
  finfoNumber: number;
  mgSupplierId: number;
  primaryText: string;
  secondaryText?: string;

  agreementPrices: ItemAgreementPrice[];
}

export class PriceListItem {
  mgSupplierItemId: number;
  mgItemNumber: number;
  finfoNumber: number;
  mgSupplierId: number;
  primaryText: string;
  secondaryText?: string;

  agreementPrices: ItemAgreementPrice[];

  constructor({
    mgSupplierItemId,
    mgItemNumber,
    finfoNumber,
    mgSupplierId,
    primaryText,
    secondaryText,
    agreementPrices,
  }: PriceListItemProps) {
    this.mgSupplierItemId = mgSupplierItemId;
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.mgSupplierId = mgSupplierId;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.agreementPrices = agreementPrices;
  }

  static fromDto = (dto: PriceListItemDTO): PriceListItem =>
    new PriceListItem({
      mgSupplierItemId: dto.mgSupplierItemId,
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      mgSupplierId: dto.mgSupplierId,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      agreementPrices: dto.agreementPrices.map(ItemAgreementPrice.fromDto),
    });
}

export interface ItemAgreementPriceProps {
  agreementId: number;
  price?: number;
  priceUnit?: PriceUnit;
  priceType?: PriceType;
  validFrom?: string;
  validTo?: string;
  validationStatus?: string;
}

export class ItemAgreementPrice {
  agreementId: number;
  price?: number;
  priceUnit?: PriceUnit;
  priceType?: PriceType;
  validFrom?: string;
  validTo?: string;
  validationStatus?: string;

  constructor({
    agreementId,
    price,
    priceUnit,
    priceType,
    validFrom,
    validTo,
    validationStatus,
  }: ItemAgreementPriceProps) {
    this.agreementId = agreementId;
    this.price = price;
    this.priceUnit = priceUnit;
    this.priceType = priceType;
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.validationStatus = validationStatus;
  }

  static fromDto = (dto: ItemAgreementPriceDTO): ItemAgreementPrice =>
    new ItemAgreementPrice({
      agreementId: dto.agreementId,
      price: dto.price,
      priceUnit: dto.priceUnit,
      priceType: dto.priceType,
      validFrom: dto.validFrom,
      validTo: dto.validTo,
      validationStatus: dto.validationStatus,
    });
}
